// extracted by mini-css-extract-plugin
export var actionButton = "_p7-0";
export var actionMenuContainer = "_p7-i";
export var bubble = "_p7-2";
export var bubbleActionMenu = "_p7-j";
export var bubbleContext = "_p7-6";
export var bubbleItems = "_p7-7";
export var customer = "_p7-3";
export var divider = "_p7-8";
export var fileList = "_p7-9";
export var hiddenComment = "_p7-o";
export var infoAbove = "_p7-a";
export var internal = "_p7-4";
export var lightActionButton = "_p7-1";
export var link = "_p7-b";
export var merchant = "_p7-5";
export var message = "_p7-c";
export var profilePicture = "_p7-e";
export var quillToolbarContainer = "_p7-f";
export var senderDate = "_p7-g";
export var senderDateCustomer = "_p7-h";
export var senderName = "_p7-d";
export var time = "_p7-k";
export var uploadedImage = "_p7-l";
export var username = "_p7-m";
export var xsmall = "_p7-n";